import type { HugeiconsProps } from '@hugeicons/react-native';
import {
  Delete02Icon as Delete02SolidIcon,
  Mail01Icon as Mail01SolidIcon,
  Mailbox01Icon as Mailbox01SolidIcon,
  Search02Icon as Search02SolidIcon,
  UserCircleIcon as UserCircleSolidIcon,
} from '@hugeicons-pro/core-solid-rounded';
import {
  Delete02Icon,
  Mail01Icon,
  Mailbox01Icon,
  Search02Icon,
  UserCircleIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import type { TFunction } from 'i18next';

import { messageListTypes, type MessageListType } from '~/constants/lists';

export interface IMessageListItem {
  value: MessageListType;
  label: string;
  icon: HugeiconsProps['icon'];
  solidIcon: HugeiconsProps['icon'];
  href: string;
  separatorBefore?: boolean;
  sectionTitleBefore?: string;
}

const messageIcons: Record<MessageListType, [HugeiconsProps['icon'], HugeiconsProps['icon']]> = {
  inbox: [Mail01Icon, Mail01SolidIcon],
  unread: [Mailbox01Icon, Mailbox01SolidIcon],
  online: [UserCircleIcon, UserCircleSolidIcon],
  deleted: [Delete02Icon, Delete02SolidIcon],
  search: [Search02Icon, Search02SolidIcon],
};

export function getMessageListHref(listType: MessageListType): string {
  return `/messages/${listType}`;
}

export function getMessageListTypeFromPathname(pathname?: string | null): MessageListType | null {
  if (!pathname?.startsWith('/messages')) {
    return null;
  }

  const matchedType = messageListTypes.find((listType) =>
    pathname.startsWith(`/messages/${listType}`)
  );
  return matchedType ?? 'inbox';
}

export function getMessageListItems(t: TFunction): IMessageListItem[] {
  return messageListTypes.map((listType, index) => {
    const [icon, solidIcon] = messageIcons[listType];

    return {
      value: listType,
      label: t(`messages.${listType}`),
      icon,
      solidIcon,
      href: getMessageListHref(listType),
      separatorBefore: listType === 'deleted' || listType === 'search',
      sectionTitleBefore: index === 0 ? t('messages.title') : undefined,
    };
  });
}
